"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    __orignlyPaddleInitialized?: boolean;
    __orignlyPaddleSessionHandled?: boolean;
    Paddle?: {
      Checkout?: {
        open?: (options: { transactionId: string }) => void;
        close?: () => void;
      };
      Environment?: {
        set: (environment: string) => void;
      };
      Initialize: (options: {
        token: string;
        eventCallback?: (event: {
          name?: string;
          data?: Record<string, unknown>;
        }) => void;
      }) => void;
    };
  }
}

const paddleToken = process.env.NEXT_PUBLIC_PADDLE_CLIENT_TOKEN;
const paddleEnvironment =
  process.env.NEXT_PUBLIC_PADDLE_ENVIRONMENT || "sandbox";

export default function PaddleInitializer() {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const paddleTransactionToken = searchParams.get("_ptxn");

    if (
      paddleTransactionToken &&
      window.location.hostname === "localhost"
    ) {
      const rewrittenLocalUrl = `http://localhost:3000${window.location.pathname}${window.location.search}${window.location.hash}`;

      if (window.location.href !== rewrittenLocalUrl) {
        window.location.replace(rewrittenLocalUrl);
        return;
      }
    }

    if (!paddleToken) {
      if (!paddleToken) {
        console.warn(
          "Paddle client token is missing. Set NEXT_PUBLIC_PADDLE_CLIENT_TOKEN to enable checkout overlay."
        );
      }
      return;
    }

    let intervalId: ReturnType<typeof setInterval> | null = null;

    const initializePaddle = () => {
      if (
        !window.Paddle ||
        window.__orignlyPaddleInitialized
      ) {
        return;
      }

      if (window.Paddle.Environment?.set) {
        window.Paddle.Environment.set(paddleEnvironment);
      }

      window.Paddle.Initialize({
        token: paddleToken,
        eventCallback: (event) => {
          if (!event?.name) return;

          window.dispatchEvent(
            new CustomEvent("orignly-paddle-event", {
              detail: event,
            })
          );
        },
      });

      window.__orignlyPaddleInitialized = true;

      if (intervalId) {
        clearInterval(intervalId);
      }
    };

    initializePaddle();

    if (!window.__orignlyPaddleInitialized) {
      intervalId = setInterval(initializePaddle, 250);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  return null;
}
